module.exports = window["MaterialUI"].IconButton;